import { Stack, Typography, Tooltip } from '@mui/material';
import { Switch } from '@/components/ui/switch';
import { FAIcon } from '@packages/ui-components';

type Props = {
  label: string;
  tooltip: string;
  enabled: boolean;
  onChange: (enabled: boolean) => void;
};

export const ToggleField = ({ enabled, onChange, label, tooltip }: Props) => {
  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      sx={{
        height: '44px',
        padding: '16px',
        alignItems: 'center',
        gap: '10px',
        borderRadius: '8px',
        border: '1px solid #D0D5DD',
        background: '#FFF',
      }}
    >
      <Stack direction="row" alignItems="center" gap="5px">
        <Typography
          sx={{
            color: 'rgba(0, 0, 0, 0.87)',
            fontFeatureSettings: "'liga' off, 'clig' off",
            fontFamily: 'Roboto',
            fontSize: '16px',
            fontStyle: 'normal',
            fontWeight: 400,
            lineHeight: '150%',
            letterSpacing: 0.15,
          }}
        >
          {label}
        </Typography>

        {tooltip && (
          <Tooltip title={tooltip} arrow>
            <FAIcon
              icon="faCircleInfo"
              size={14}
              color="#828282"
              style={{
                cursor: 'help',
                padding: '2px',
                fontSize: '14px',
              }}
              onClick={(e) => e.stopPropagation()}
            />
          </Tooltip>
        )}
      </Stack>

      <Switch size="large" checked={enabled} onChange={(_, checked) => onChange(checked)} />
    </Stack>
  );
};
